module.exports = __webpack_public_path__ + "img/Assurance-Extra-Trauma.328ee228.jpg";